var s = {};
export {
  s as __exports
};
//# sourceMappingURL=index.es336.js.map
